import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import BacktestResults from './pages/BacktestResults';
import OrbBacktest from './pages/OrbBacktest';
import AiBiasStrategy from './pages/AiBiasStrategy';
import AiBiasTradesLog from './pages/AiBiasTradesLog';
import SwingWeekly from './pages/SwingWeekly';
import OllamaEval from './pages/OllamaEval';
import Dashboard from './pages/Dashboard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/backtesting/results" element={<BacktestResults />} />
        <Route path="/backtesting/orb" element={<OrbBacktest />} />
        <Route path="/backtesting/ai-bias" element={<AiBiasStrategy />} />
        <Route path="/backtesting/ai-bias-trades" element={<AiBiasTradesLog />} />
        <Route path="/backtesting/swing-weekly" element={<SwingWeekly />} />
        <Route path="/backtesting/ollama-eval" element={<OllamaEval />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
